module.exports = {
    "Clear search": `Ryd s\xf8gning`
};


//# sourceMappingURL=da-DK.main.js.map
